module.exports = __webpack_public_path__ + "d6e66f97cf0d3c0161b576291d2ac737.pdf";